import axios
	from "axios"
import store
	from "./../globals"
import _
	from "lodash"

import {isNotEmpty, toAcceptableDate}
	from "./../common"

const API_URL = process.env.REACT_APP_API_URL

class AuthService
{
	sessionToken = store.getState().sessionToken.value

	constructor()
	{
		store.subscribe(() => this.sessionToken = store.getState().sessionToken.value)
	}

	login(email : string, password : string)
	{
		return axios.post
		(
			API_URL + "/access/_login",
			{
				email,
				password,
				//Marca de la WAPP de hoy: el servidor rechaza el login de la app vieja de
				//ANIGAMI, que no la manda (AuthController::login, 2026-10-01).
				cliente : "wapp"
			}
		);
	}


	//Self-service password reset: step 1 emails a link, step 2 sets the new password with the token from that link.
	requestPasswordReset(email : string)
	{
		return axios.post(API_URL + "/access/_pwdReset", {email});
	}

	confirmPasswordReset(token : string, email : string, password : string, passwordConfirm : string)
	{
		return axios.post
		(
			API_URL + "/access/_pwdResetConfirm",
			{
				token,
				email,
				password,
				password_confirmation : passwordConfirm
			}
		);
	}

	//Olvidé mi contraseña por código SMS al teléfono del perfil (2026-10-12).
	pedirCodigoSms(email : string)
	{
		return axios.post(API_URL + "/access/_claveSmsPedir", {email});
	}

	confirmarCodigoSms(email : string, codigo : string, password : string, passwordConfirm : string)
	{
		return axios.post(API_URL + "/access/_claveSmsConfirmar", {email, codigo, password, password_confirmation : passwordConfirm});
	}

	//Código por WhatsApp para entrar la primera vez o cambiar la contraseña (2026-10-13). canal "sms" lo manda por SMS y
	//"correo" al correo de WAPP + el personal de la ficha (2026-10-21).
	pedirCodigo(email : string, canal : "whatsapp" | "sms" | "correo" = "whatsapp")
	{
		return axios.post(API_URL + "/access/_codigoPedir", {email, canal});
	}

	confirmarCodigo(email : string, codigo : string, password : string, passwordConfirm : string)
	{
		return axios.post(API_URL + "/access/_codigoConfirmar", {email, codigo, password, password_confirmation : passwordConfirm});
	}

	//Cambiar la contraseña ya dentro (obligatorio cuando es temporal; si no, pide la actual o un código de _codigoPerfil).
	//tokenAcceso: recién entrado por WhatsApp, antes de guardar la sesión ("Crea Tu Contraseña").
	cambiarClave(password : string, passwordConfirm : string, actual? : string, codigo? : string, tokenAcceso? : string)
	{
		return axios.post
		(
			API_URL + "/access/_cambiarClave",
			{password, password_confirmation : passwordConfirm, actual, codigo},
			{headers: {Authorization : "Bearer " + (tokenAcceso || store.getState().sessionToken.value)}}
		);
	}

	/* Acceso de alumnos (2026-10-21, docs/ACCESO_ALUMNOS_CONTRATO.md). */
	whatsappPedir(telefono : string)
	{
		return axios.post(API_URL + "/access/_whatsappPedir", {telefono});
	}

	whatsappEntrar(telefono : string, codigo : string)
	{
		return axios.post(API_URL + "/access/_whatsappEntrar", {telefono, codigo, cliente : "wapp"});
	}

	//Varias cuentas con el mismo número: la escogida en el selector (boleto de un solo uso).
	whatsappElegir(boleto : string, cuenta : number)
	{
		return axios.post(API_URL + "/access/_whatsappElegir", {boleto, cuenta, cliente : "wapp"});
	}

	invitacion(token : string)
	{
		return axios.get(API_URL + "/access/_invitacion", {params : {token}});
	}

	invitacionAceptar(token : string, password : string, passwordConfirm : string)
	{
		return axios.post(API_URL + "/access/_invitacionAceptar", {token, password, password_confirmation : passwordConfirm, cliente : "wapp"});
	}

	//Mi Perfil: nombre/correo actuales y si ya tiene contraseña.
	miCuenta()
	{
		return axios.get(API_URL + "/access/_miCuenta", {headers: {Authorization : "Bearer " + store.getState().sessionToken.value}});
	}

	//Mi Perfil: código al WhatsApp de la ficha para cambiar la contraseña sin la actual.
	codigoPerfil()
	{
		return axios.post(API_URL + "/access/_codigoPerfil", {}, {headers: {Authorization : "Bearer " + store.getState().sessionToken.value}});
	}

	logout(sessionToken : string | null)
	{
		return axios.post
		(
			API_URL + "/access/_logout",
			{},
			{
				headers:
				{
					"Content-Type" : "application/json",
					Authorization  : "Bearer " + this.sessionToken
				}
			}
		)
		.then
		(
			response=>
			{
				return response.data;
			}
		);
	}

	getInitData()
	{
		return axios.get
		(
			API_URL + "/user/_initData",
			{
				headers:
				{
					"Content-Type"  : "application/json",
					"Authorization" : "Bearer " + this.sessionToken
				}
			}
		)
		.then
		(
			response=>
			{
				return response;
			}
		)
	}

	getCurrentUser()
	{
		return axios.get
		(
			API_URL + "/user/_profile",
			{
				headers:
				{
					"Content-Type"  : "application/json",
					"Authorization" : "Bearer " + this.sessionToken
				}
			}
		)
		.then
		(
			response=>
			{
				return response;
			}
		)
	}

	/** Solo la foto propia (512x512 en el servidor). */
	saveCurrentUserPhoto(file : File)
	{
		let payload : FormData = new FormData()
		payload.append("image", file)
		return axios.post
		(
			API_URL + "/user/_photo",
			payload,
			{headers : {Accept : "application/json", "Content-Type" : "multipart/form-data", Authorization : "Bearer " + this.sessionToken}}
		)
	}

	saveCurrentUser(userProfile : any)
	{
		let payload : FormData = new FormData()
		let profile : any=
		{
			nationalityId        : userProfile.nationality_id,
			cityId               : userProfile.city.id,
			location             : userProfile.location || "",
			birthday             : toAcceptableDate(userProfile.birthdayValue),
			genderId             : userProfile.gender_id,
			identificationTypeId : userProfile.identification_type_id,
			identificationCode   : userProfile.identification_code,
			firstName            : userProfile.first_name,
			lastName             : userProfile.last_name,
			email                : userProfile.email,
			password             : userProfile.password,
			links                : JSON.stringify
			({
				web       : userProfile.web || "",
				facebook  : userProfile.facebook || "",
				twitter   : userProfile.twitter || "",
				instagram : userProfile.instagram || "",
				tiktok    : userProfile.tiktok || ""
			})
		}

		for(let field of ["password", "observations", "zipcode", "address", "phone"])
		{
			if(isNotEmpty(userProfile[field]))
			{
				profile[field] = userProfile[field] + ""
			}
		}

		if(userProfile.tags.length > 0)
		{
			profile.tagIds = _.map(userProfile.tags, "id").join(",")
		}

		Object.keys(profile).map((key : string) => {payload.append(key, profile[key])})

		if(userProfile.image)
		{
			payload.append("image", userProfile.image == userProfile.imagePreview ? "" : userProfile.image)
		}

		return axios.post
		(
			API_URL + "/user/_profile?_method=PUT",
			payload,
			{
				headers:
				{
					Accept         : "application/json, text/plain, */*",
					"Content-Type" : "multipart/form-data",
					Authorization  : "Bearer " + this.sessionToken
				}
			}
		)
	}
}

export default new AuthService()